/* Copyright (c) 2017 Backpack Health LLC */

/* global IS_ANDROID_BUILD, cordova */

import React, { FC } from 'react';

import { Buttons } from '../../../../../bphComponents/bundle';
import LocalizeI18nText from '../../../../components/LocalizeI18nText';
import GroupMetadata, { GroupMetadataType } from '../../../../../models/GroupMetadata';
import { TrackEvent } from '../../../../../utilities/UserMetrics';

interface Props {
  groupMetadata: GroupMetadataType;
}
const GroupExternalLink: FC<Props> = ({ groupMetadata }) => {
  if (!groupMetadata.external_link.url.default || !groupMetadata.external_link.label.default) { return null; }
  const group = new GroupMetadata(groupMetadata);
  const groupName = group.groupName.getText();
  return (
    <LocalizeI18nText text={groupMetadata.external_link.url}>
      {
        ({ text }) => {
          const expectedLink = text.indexOf('://') > -1 ? text : `//${text}`;
          if (IS_ANDROID_BUILD) {
            return (
              <Buttons.StandardButtonVariants.PrimaryButton
                className="theme-group base background"
                onClick={() => {
                  TrackEvent.groups.groupCallToActionButton(groupName);
                  cordova.InAppBrowser.open(expectedLink, '_blank', 'location=yes');
                }}
              >
                <LocalizeI18nText text={groupMetadata.external_link.label} />
              </Buttons.StandardButtonVariants.PrimaryButton>
            );
          } else {
            return (
              <Buttons.StandardButtonVariants.PrimaryButton
                href={expectedLink}
                className="theme-group base background"
                onClick={() => {
                  TrackEvent.groups.groupCallToActionButton(groupName);
                }}
              >
                <LocalizeI18nText text={groupMetadata.external_link.label} />
              </Buttons.StandardButtonVariants.PrimaryButton>
            );
          }
        }
      }
    </LocalizeI18nText>
  );
};

export default GroupExternalLink;
